import React, { useState, useEffect, useMemo, useRef } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { Card, CardBody, CardHeader } from "reactstrap";

import { reactFormatter } from "react-tabulator";

import CTable from "common/Table/CTable";
import { CTableFormatter } from "common/Table";

import { AuthLinkCellFormatter } from "common/Table/CTableFormatter";

const TABLE_COLUMNS = [
  { title: "A", field: "a" },
  { title: "B", field: "b" },
]

const TABLE_DATA = [...Array(50).keys()].map(i => {return {a: `a${i}`, b:`b${i}`};})

const LINK_TEST_TABLE_COLUMNS = [
  { title: "Link", field: "link" },
  { title: "NoAuth", field: "noauth", formatter: "link", 
    formatterParams: {
      label: (cell) => CTableFormatter.getDocumentName(cell),
      urlPrefix: process.env.REACT_APP_FILE_PATH  + "EventExpenditure/",
      target: "_blank",
    },
  },
  { title: "Auth", field: "auth", formatter: reactFormatter(
    <AuthLinkCellFormatter
      urlPrefix={`${process.env.REACT_APP_FILE_PATH_AUTH}EventExpenditure/`}
      target="_blank"
    />
  ),
  },
]

const LINK_TEST_TABLE_DATA = [{
  link: 'Test the link',
  noauth: 'test.pdf',
  auth: 'test.pdf',
}]

// Row and Cells are re-rendering for all state changes, not just data
// https://github.com/ngduc/react-tabulator/issues/82

const CTableTest = (props) => {
  const location = useLocation();
  const cTableRef = useRef();

  const loadData = async () => {
    console.log("CTableTest loadData");
    return Promise.resolve(LINK_TEST_TABLE_DATA);
  }

  useEffect(() => {
    if (cTableRef.current) {
      cTableRef.current.loadData();
    }
  }, []);

  return (
    <div id="accordion " className="animated fadeIn">
      <Card className="mb-0 min-vh-80">
        <CardHeader id="headingOne">
          <h5 className="m-0 p-0">CTable Test</h5>
        </CardHeader>
        <CardBody>
          <CTable
            {...props}
            id="cTableTest"
            idPrefix="cTableTest"
            key="cTableTest"
            ref={cTableRef}
            columns={LINK_TEST_TABLE_COLUMNS}
            data={LINK_TEST_TABLE_DATA}
            selectable={1}
            loadDataCustom={loadData}
            pagesize={50}
          />
        </CardBody>
      </Card>
    </div >
  );
}

export default withRouter(CTableTest);
